<script setup>
import { ref, computed, onMounted } from 'vue'
import Paginate from "vuejs-paginate-next"

const props = defineProps({
  pageInfo: {
    type: Object,
    default: () => 
      ({
        page: 1,
        pageCount: 1,
        pagination: 10
      }),
    required: true
  },
  total: {
    type: Number,
    default: 0,
    required: true
  }
})

const emits = defineEmits([
  'changePage'
])

const perPage = 1

const clickCallback = (pageNum) => {
  console.log('clickCallback', pageNum)
  emits('changePage', pageNum)
}

onMounted(() => {
  console.log('mounted')
})
</script>

<template>
  <div class="pagerWrapper">
    <p>全{{ total }}件</p>
    <div
      v-if="total > 0"
      class="pagerContainer"
    >
      <paginate
        :page-count="pageInfo.pageCount"
        :page-range="2"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="'<'"
        :next-text="'>'"
        :container-class="'pagination'"
        :page-class="'page-item'"
      >
      </paginate>
    </div>
  </div>
</template>

<style scoped lang="scss">
.pagerWrapper {
  display: flex;
  justify-content: space-between;
  height: 34px;

  p {
    padding-top: 7px;
  }

}
</style>

<style lang="scss">
.pagerWrapper {
  .pagination {
    height: 32px;
    margin: 0;
    display: inline-block;
    padding-left: 0;
    border-radius: 4px;

    
    li {
      display: inline;
      a,
      span {
        border: none;
        outline: none !important;
        position: relative;
        float: left;
        padding: 6px 12px;
        margin-left: -1px;
        line-height: 1.42857143;
        color: #337ab7;
        text-decoration: none;
        background-color: #fff;
      }
      &.active > a,
      &.active > span,
      &.active > a:hover,
      &.active > span:hover,
      &.active > a:focus,
      &.active > span:focus {
        z-index: 2;
        color: #fff;
        cursor: default;
        background-color: #337ab7;
        border-color: #337ab7;
      }

      &.disabled > a,
      &.disabled > span,
      &.disabled > a:hover,
      &.disabled > span:hover,
      &.disabled > a:focus,
      &.disabled > span:focus {
        color: #CCC;
        cursor: not-allowed;
      }
    }

    
    > li:first-child > a,
    > li:first-child > span {
      margin-left: 0;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
}
</style>
